import { DisplayItem } from 'design-system';

/**
 * Unified source for the notification preferences options
 */
export const notificationPreferences: DisplayItem[] = [
  { Value: 'cellPhone', Text: 'Celular' },
  { Value: 'email', Text: 'Correo' },
];

export default notificationPreferences;
